import type { FC } from "react";
import { useEffect } from "react";

import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";

import { Dropdown, SubsectionItem, EPrimaryItemType } from "@similarweb/ui-components";

import "app/components/React/UserSettingDropdown/UserSettingsDropdown.scss";

import { toggleUserSettings } from "app/actions/userData/primarySidebar3Actions";
import { UserSettingsWrapper } from "app/components/sidebar3/primary-side-bar/styledComponents";
import type { ISecondaryAction } from "app/components/sidebar3/primary-side-bar/types";

export const SecondaryActionDropdown: FC<ISecondaryAction> = ({
    title,
    iconName,
    onClick,
    isPrimarySidebarOpen,
    content,
    dropdownRef,
}) => {
    const dispatch = useDispatch();

    const { isUserOnMobileDevice } = useSelector((state) => state.isUserOnMobileDevice);

    useEffect(() => {
        dispatch(toggleUserSettings(false));
    }, []);

    const dropdownClassContainer = classNames(
        "DropdownContent-container",
        "UserSettingsDropDownContent-container-sidebar3",
        { "mobile-right": isUserOnMobileDevice },
    );

    return (
        <Dropdown
            ref={dropdownRef}
            width={211}
            dropdownPopupHeight={window.outerHeight <= 768 ? 500 : 714}
            buttonWidth={"auto"}
            appendTo={"body"}
            dropdownPopupPlacement="right"
            closeOnItemClick={false}
            cssClassContainer={dropdownClassContainer}
            onToggle={(isOpen) => dispatch(toggleUserSettings(isOpen))}
        >
            {[
                <UserSettingsWrapper key={`${title}-wrapper`}>
                    <SubsectionItem
                        key={`${title}-dropdown-button`}
                        itemText={title}
                        itemType={EPrimaryItemType.SecondaryAction}
                        onItemClick={onClick}
                        icon={iconName}
                        isCollapsed={!isPrimarySidebarOpen}
                    />
                </UserSettingsWrapper>,
                ...content,
            ]}
        </Dropdown>
    );
};
